import { api } from './api';

export function getUserPathwaysAPI(username: string, callback) {
  const data = {
    username,
  };
  api.ibledxpathway.getUserPathways(data, function (data) {
    callback(data);
  });
}
